import React, { FC } from 'react';
import Modal from '@common/modal';

import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './alreadySupportedModal.module.scss';
const cx = classnames.bind(styles);

interface IAlreadySupportedModalProps {
  visible: boolean;
  onClose: () => void;
}

const AlreadySupportedModal: FC<IAlreadySupportedModalProps> = ({ visible, onClose }) => {
  const onClickBtn = () => {
    onClose();
    V2Route.goMainPage();
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>
          해당 계정으로
          <br />
          이미 지원한 이력이 있습니다.
        </strong>

        <p className={cx('desc')}>중복 지원은 불가하니 다시 한번 확인해 주세요.</p>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'confirm')} role="button" onClick={onClickBtn}>
            메인으로 가기
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default AlreadySupportedModal;
